import { render, staticRenderFns } from "./CapturaFoto.vue?vue&type=template&id=a6644098&"
import script from "./CapturaFoto.vue?vue&type=script&lang=js&"
export * from "./CapturaFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports